var _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpDownChevronsSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 19,
    viewBox: "0 0 12 19",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12v18.8253h-12z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.29289 18.1181c.39052.3906 1.02373.3906 1.41428 0l4.58763-4.5876c.3895-.3895.3898-1.0211.0005-1.4109-.3898-.3903-1.0222-.3904-1.41216-.0003l-3.17573 3.1778c-.3906.3909-1.02418.3909-1.41475 0l-3.17531-3.1781c-.3897-.3901-1.02184-.3902-1.411709-.0003-.389724.3897-.389751 1.0215-.000059 1.4113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.70711.707237c-.39052-.390579-1.02373-.390605-1.41428-.000058l-4.58762 4.587621c-.389558.38956-.38978 1.02109-.000499 1.41092.389759.39031 1.022239.39043 1.412149.00027l3.17573-3.1778c.3906-.39086 1.02418-.39083 1.41475.00008l3.17531 3.17807c.38975.39004 1.02185.39018 1.41175.00031.3897-.38972.3897-1.02158 0-1.41134z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownChevronsSvg);
export default __webpack_public_path__ + "static/media/UpDownChevronsSVG.7e1a719c.svg";
export { ForwardRef as ReactComponent };